import { COORDINATOR } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { usernameSelector, defaultUserGroupSelector } from '../auth/auth-selectors';

const SET_CREATE_CRQ_COORDINATOR = 'SET_CREATE_CRQ_COORDINATOR';
const SET_CREATE_CRQ_COORDINATOR_GROUP = 'SET_CREATE_CRQ_COORDINATOR_GROUP';
const SET_CREATE_CRQ_COORDINATOR_AND_GROUP = 'SET_CREATE_CRQ_COORDINATOR_AND_GROUP';


const setCreateCrqCoordinator = (coordinator) => ({
  type: SET_CREATE_CRQ_COORDINATOR,
  payload: {
    coordinator,
  },
});

const setCreateCrqCoordinatorAndGroup = ({
  coordinatorId,
  coordinatorName,
  coordinatorGroup,
}) => ({
  type: SET_CREATE_CRQ_COORDINATOR_AND_GROUP,
  payload: {
    coordinatorId,
    coordinatorName,
    coordinatorGroup,
  },
});

const setCreateCrqCoordinatorGroup = (coordinatorGroup) => ({
  type: SET_CREATE_CRQ_COORDINATOR_GROUP,
  payload: {
    coordinatorGroup,
  },
});

// thunk action to set the coordinator and coordinator group in the create crq form to the value
// for the logged in user. use a thunk action to allow us to retrieve auth info from state
const setCreateCrqCoordinatorToLoggedInUser = (network) => (dispatch, getState) => {
  const state = getState();
  const {
    roles,
    remedyIds,
  } = state.auth.user;
  const userName = usernameSelector(state);
  const defaultGroupByNetwork = defaultUserGroupSelector(state);
  const remedyId = remedyIds[((network === 'fixedOlo') || (network === 'fixedInternational')) ? 'fixed' : network];
  // if the logged in users role for the selected network is coordinator
  // and the user has a remedy id for the network
  // use this id as the coordinatorId
  // otherwise set it to null
  const coordinatorId = remedyId && roles[((network === 'fixedOlo') || (network === 'fixedInternational')) ? 'fixed' : network] === COORDINATOR ? remedyId : null;
  const coordinatorName = coordinatorId ? userName : null;
  const coordinatorGroup = defaultGroupByNetwork[((network === 'fixedOlo') || (network === 'fixedInternational')) ? 'fixed' : network];
  // set the coordinatorId in redux
  dispatch(setCreateCrqCoordinatorAndGroup({
    coordinatorId,
    coordinatorName,
    coordinatorGroup,
  }));
};

export {
  setCreateCrqCoordinator,
  setCreateCrqCoordinatorGroup,
  setCreateCrqCoordinatorAndGroup,
  setCreateCrqCoordinatorToLoggedInUser,
  SET_CREATE_CRQ_COORDINATOR,
  SET_CREATE_CRQ_COORDINATOR_GROUP,
  SET_CREATE_CRQ_COORDINATOR_AND_GROUP,
};
